import { render, staticRenderFns } from "./SwitchRole.vue?vue&type=template&id=1f4bf79f&scoped=true&lang=html&"
import script from "./SwitchRole.vue?vue&type=script&lang=js&"
export * from "./SwitchRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4bf79f",
  null
  
)

export default component.exports